import XRegExp from 'xregexp';
import {removeTagsFromText} from '../../pages/branding/emailSubjectTextEditor/EmailSubjectTextEditor.js';
import {replaceVariablesInDelta, deltaToHtml} from './Variables.js';

export const cleanText = (text) => {
    const regexPattern = XRegExp('[' +
        '\\x00-\\x09' +   // ASCII Control characters from 0x00 to 0x09
        '\\x0B-\\x1F' +   // ASCII Control characters from 0x0B to 0x1F
        '\\x7F-\\x9F' +   // More control characters
        '\\u00A0' +       // Non-breaking space
        '\\u200B-\\u200F' + // Zero-width space and bidirectional text controls
        '\\u00AD' +       // Soft hyphen
        '\\u2060' +       // Word joiner
        '\\uFEFF' +       // Zero width no-break space (Byte Order Mark)
    ']', 'g');

    const cleanedText = XRegExp.replace(text, regexPattern, '');
    return cleanedText;
};

export const decodeHtmlEntities = (text) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
};

export const removeHiddenSpace = (string) => 
    string.split('').filter((_, index) => string.charCodeAt(index) !== 65279).join('');

export const clearText = (string) => removeTagsFromText(removeHiddenSpace(string));

const preserveImageStyles = (quill, htmlString) => {
    if(!quill?.root || !htmlString) return htmlString;
    
    const stylesMap = new Map();
    quill.root.querySelectorAll('img').forEach(img => {
        const src = img.getAttribute('src');
        if(src && (img.style.width || img.style.height)) {
            stylesMap.set(src, {width: img.style.width, height: img.style.height});
        }
    });
    
    if(stylesMap.size === 0) return htmlString;
    
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    tempDiv.querySelectorAll('img').forEach(img => {
        const styles = stylesMap.get(img.getAttribute('src'));
        if(styles) {
            if(styles.width) img.style.width = styles.width;
            if(styles.height) img.style.height = styles.height;
        }
    });
    
    return tempDiv.innerHTML;
};

export const convertTextBeforeSave = (quillRef) => {
    if(!quillRef.current) return '';
    const quill = quillRef.current.getEditor();
    if(!quill) return '';
    const delta = quill.getContents();
    const contentWithPlaceholders = replaceVariablesInDelta(delta);
    const htmlOutput = deltaToHtml(contentWithPlaceholders);
    return preserveImageStyles(quill, htmlOutput);
};

export const restoreImageStyles = (quill, htmlString) => {
    if(!quill?.root || !htmlString) return;
    
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    const stylesMap = new Map();
    tempDiv.querySelectorAll('img').forEach(img => {
        const src = img.getAttribute('src');
        if(src) {
            const width = img.style.width || (img.getAttribute('width') ? `${img.getAttribute('width')}px` : null);
            const height = img.style.height || (img.getAttribute('height') ? `${img.getAttribute('height')}px` : null);
            if(width || height) {
                stylesMap.set(src, {width, height});
            }
        }
    });
    
    if(stylesMap.size === 0) return;
    
    quill.root.querySelectorAll('img').forEach(img => {
        const styles = stylesMap.get(img.getAttribute('src'));
        if(styles) {
            if(styles.width) img.style.width = styles.width;
            if(styles.height) img.style.height = styles.height;
        }
    });
};

export const hasDisabledVariables = (quillRef, disabledVariables) => {
    const quill = quillRef?.current?.getEditor();
    if(quill) {
        const html = quill?.root?.innerHTML;
        return Object.keys(disabledVariables).some((key) => html.includes(`data-label="${key}"`));
    }
    return false;
};

export const SANITIZE_CONFIG = {
    ALLOWED_TAGS: ['p', 'br', 'span', 'a', 'strong', 'em', 'u', 's', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'blockquote', 'code', 'pre', 'img', 'iframe'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'data-label', 'src', 'alt', 'style', 'allow', 'allowfullscreen', 'frameborder', 'width', 'height']
};

